/**
 * Only display children if we're in the snap mode.
 */

import { useDeviceType } from "@/common/hooks/useDeviceType";
import { useAppStore } from "@/common/store/appStore";
import { useFeedStore } from "@/common/store/useFeedStore";
import { deviceTypeEnum } from "@/common/utils/device";
import { useMemo } from "react";

interface IProps {
  children: React.ReactNode;
}

export const SnapOnly = ({ children }: IProps) => {
  const isFullScreen = useAppStore((state) => state.isFullScreen);
  const isV2HeaderEnabled = useFeedStore((state) => state.isV2HeaderEnabled);
  const isMobile = useDeviceType() === deviceTypeEnum.PHONE;
  const snapAvailable = useMemo(() => isMobile && isV2HeaderEnabled, [isMobile, isV2HeaderEnabled]);

  if (snapAvailable || isFullScreen) {
    return <>{children}</>;
  }

  return null;
};
